import { EventEmitter, Inject, Injectable, Output, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class CartService {

    @Output() getUpdatedCart: EventEmitter<any> = new EventEmitter();
    cartKey: string = "cart";
    defaultTax: number = 22;

    constructor(@Inject(PLATFORM_ID) private platformId: any) {

    }

    /* ITEMS */

    createFromItem(item: Item, billingProfile: UserBillingProfile): CartItem {

        var unit_price = +item.Price.replace(",", ".");
        var tax = billingProfile != null ? +billingProfile.Tax.replace(",", ".") : this.defaultTax;
        var unit_tax_amount = +(unit_price * tax / 100).toFixed(2);

        var unit_taxed_price = unit_price + unit_tax_amount;
        var taxed_price = unit_taxed_price.toFixed(2).replace(".", ",");

        return <CartItem>{
            Item: item,
            Quantity: 1,
            Tax: tax.toFixed(2).replace(".", ","),
            UnitPrice: unit_price.toFixed(2).replace(".", ","),
            UnitTaxedPrice: taxed_price,
            TotalPrice: unit_price.toFixed(2).replace(".", ","),
            TotalTaxedPrice: taxed_price
        };

    }

    createFromDemo(item: Item, demo: Demo, billingProfile: UserBillingProfile): CartItem {

        var unit_price = +demo.Price.replace(",", ".");

        var tax = billingProfile != null ? +billingProfile.Tax.replace(",", ".") : this.defaultTax;
        var unit_tax_amount = +(unit_price * tax / 100).toFixed(2);

        var unit_taxed_price = unit_price + unit_tax_amount;
        var taxed_price = unit_taxed_price.toFixed(2).replace(".", ",");

        return <CartItem>{
            Item: item,
            Demo: demo,
            Quantity: 1,
            Tax: tax.toFixed(2).replace(".", ","),
            UnitPrice: unit_price.toFixed(2).replace(".", ","),
            UnitTaxedPrice: taxed_price,
            TotalPrice: unit_price.toFixed(2).replace(".", ","),
            TotalTaxedPrice: taxed_price
        };

    }

    add(item: CartItem) {

        if (isPlatformBrowser(this.platformId)) {

            let items = [];
            let data = localStorage.getItem(this.cartKey);
            if (data !== null) {
                items = JSON.parse(data);
            }

            // check if the item is already in the cart
            var i = items.findIndex(p => p.Item.Id == item.Item.Id && p.Demo == item.Demo);
            if (i >= 0) {

                var quantity = items[i].Quantity + 1;

                if (item.Item.DiscountMinQuantity && quantity == item.Item.DiscountMinQuantity && item.Item.DiscountPrice) {

                    items[i].UnitPrice = item.Item.DiscountPrice;
                    items[i].UnitTaxedPrice = item.Item.DiscountTaxedPrice;
                    item.UnitPrice = item.Item.DiscountPrice;

                }

                var unit_price = +item.UnitPrice.replace(",", ".");
                var total_price = unit_price * quantity;
                var tax = +item.Tax.replace(",", ".");
                var unit_tax_amount = unit_price * tax / 100;
                var total_tax_amount = unit_tax_amount * quantity;
                var total_taxed_price = total_price + total_tax_amount;

                items[i].Quantity = quantity;
                items[i].TotalPrice = total_price.toFixed(2).replace(".", ",");
                items[i].TotalTaxedPrice = total_taxed_price.toFixed(2).replace(".", ",");

            }
            else {

                // if not exist, insert the item in the cart
                items.push(item);

            }

            localStorage.setItem(this.cartKey, JSON.stringify(items));

            this.emitUpdateCart();

        }
    }

    getItems(): CartItem[] {

        if (isPlatformBrowser(this.platformId)) {

            let data = localStorage.getItem(this.cartKey);
            if (data !== null) {
                return JSON.parse(data);
            }

        }

        return [];

    }

    removeItem(item: CartItem) {

        if (isPlatformBrowser(this.platformId)) {

            let data = localStorage.getItem(this.cartKey);
            if (data !== null) {

                var items = JSON.parse(data);

                if (item.Demo) {

                    var i = items.findIndex(p => p.Demo && p.Demo.Id == item.Demo.Id);
                    if (i >= 0) {
                        items.splice(i, 1);
                    }

                }
                else {

                    var i = items.findIndex(p => p.Item.Id == item.Item.Id);
                    if (i >= 0) {
                        items.splice(i, 1);
                    }

                }


                localStorage.setItem(this.cartKey, JSON.stringify(items));
                this.emitUpdateCart();
            }

        }

    }

    increaseItemQuantity(item: CartItem) {

        if (isPlatformBrowser(this.platformId)) {

            let data = localStorage.getItem(this.cartKey);
            if (data !== null) {

                var items = JSON.parse(data);

                var i = items.findIndex(p => p.Item.Id == item.Item.Id && !p.Demo);
                if (i >= 0) {

                    var quantity = items[i].Quantity + 1;

                    if (item.Item.DiscountMinQuantity && quantity == item.Item.DiscountMinQuantity && item.Item.DiscountPrice) {

                        items[i].UnitPrice = item.Item.DiscountPrice;
                        items[i].UnitTaxedPrice = item.Item.DiscountTaxedPrice;
                        item.UnitPrice = item.Item.DiscountPrice;

                    }

                    var unit_price = +item.UnitPrice.replace(",", ".");
                    var total_price = unit_price * quantity;
                    var tax = +item.Tax.replace(",", ".");
                    var unit_tax_amount = unit_price * tax / 100;
                    var total_tax_amount = unit_tax_amount * quantity;
                    var total_taxed_price = total_price + total_tax_amount;

                    items[i].Quantity = quantity;
                    items[i].TotalPrice = total_price.toFixed(2).replace(".", ",");
                    items[i].TotalTaxedPrice = total_taxed_price.toFixed(2).replace(".", ",");

                }

                localStorage.setItem(this.cartKey, JSON.stringify(items));
                this.emitUpdateCart();
            }

        }

    }

    decreaseItemQuantity(item: CartItem) {

        if (isPlatformBrowser(this.platformId)) {

            let data = localStorage.getItem(this.cartKey);
            if (data !== null) {

                var items = JSON.parse(data);

                var i = items.findIndex(p => p.Item.Id == item.Item.Id && !p.Demo);
                if (i >= 0) {

                    var quantity = items[i].Quantity - 1;

                    if (item.Item.DiscountMinQuantity && quantity == item.Item.DiscountMinQuantity - 1 && item.Item.DiscountPrice) {

                        items[i].UnitPrice = item.Item.Price;
                        items[i].UnitTaxedPrice = item.Item.TaxedPrice;
                        item.UnitPrice = item.Item.Price;

                    }

                    var unit_price = +item.UnitPrice.replace(",", ".");
                    var total_price = unit_price * quantity;
                    var tax = +item.Tax.replace(",", ".");
                    var unit_tax_amount = unit_price * tax / 100;
                    var total_tax_amount = unit_tax_amount * quantity;
                    var total_taxed_price = total_price + total_tax_amount;

                    items[i].Quantity = quantity;
                    items[i].TotalPrice = total_price.toFixed(2).replace(".", ",");
                    items[i].TotalTaxedPrice = total_taxed_price.toFixed(2).replace(".", ",");

                }

                localStorage.setItem(this.cartKey, JSON.stringify(items));
                this.emitUpdateCart();
            }

        }

    }

    getOrderItems(): OrderItem[] {

        var order_items: OrderItem[] = [];

        if (isPlatformBrowser(this.platformId)) {

            let data = localStorage.getItem(this.cartKey);
            if (data !== null) {

                var items = JSON.parse(data);

                for (let i in items) {

                    var order_item = <OrderItem>{};

                    order_item.Item = items[i].Item.Name;
                    order_item.ItemSlug = items[i].Item.Slug;
                    order_item.ItemId = items[i].Item.Id;
                    if (items[i].Demo) order_item.DemoId = items[i].Demo.Id;
                    order_item.Quantity = items[i].Quantity;
                    order_item.Tax = items[i].Tax;
                    order_item.UnitPrice = items[i].UnitPrice;
                    order_item.UnitTaxedPrice = items[i].UnitTaxedPrice;
                    order_item.TotalPrice = items[i].TotalPrice;
                    order_item.TotalTaxedPrice = items[i].TotalTaxedPrice;

                    order_items.push(order_item);
                }
            }

        }

        return order_items;

    }

    getTotalAmount(): number {

        var totalAmount = 0;
        var items = this.getItems();
        for (let item of items) {
            totalAmount += (+item.TotalPrice.replace(",", "."));
        }

        return totalAmount;

    }

    getTotalTaxAmount(): number {

        var totalAmount = 0;
        var items = this.getItems();
        for (let item of items) {
            totalAmount += ((+item.TotalPrice.replace(",", ".")) * (+item.Tax.replace(",", ".")) / 100);
        }

        return totalAmount;

    }

    getTotalTaxedAmount(): number {

        var totalAmount = 0;
        var items = this.getItems();

        for (let item of items) {
            totalAmount += (+item.TotalTaxedPrice.replace(",", "."));
        }

        return totalAmount;

    }

    getTotalQuantity(): number {

        var quantity = 0;
        var items = this.getItems();

        for (let item of items) {
            quantity += (+item.Quantity);
        }

        return quantity;

    }

    empty() {
        localStorage.removeItem(this.cartKey);
        this.emitUpdateCart();
    }

    emitUpdateCart() {
        this.getUpdatedCart.emit();
    }

}


// WEBPACK FOOTER //
// ./ClientApp/app/_services/cart.service.ts